import VideoCard from "./video-card.vue";
export default VideoCard;
